import { Navigate } from 'react-router-dom'

import { AuthRootPage } from './pages/auth-root'
import { LoginPage } from './pages/login/Login.page'

import type { RouteObject } from 'react-router-dom'

const authRoutes: RouteObject[] = [
  {
    path: 'login',
    element: <AuthRootPage />,
    children: [
      {
        index: true,
        element: <LoginPage />,
      },
      {
        path: 'abroad',
        element: <LoginPage isAbroad={true} />,
      },
      {
        path: '*',
        element: <Navigate to='../..' replace />,
      },
    ],
  },
]

export { authRoutes }
